import { render, staticRenderFns } from "./EventSubscriptions.vue?vue&type=template&id=052e08b8&scoped=true"
import script from "./EventSubscriptions.vue?vue&type=script&lang=js"
export * from "./EventSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052e08b8",
  null
  
)

export default component.exports